
import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import routes from "routes.js";

var UserProfile = (function() {
    

    var setUser = function(data)
    {
        localStorage.setItem('user', JSON.stringify(data));
        return true;
    }

    var getUser = async function()
    {
        let user = localStorage.getItem("user");
        return JSON.parse(user);
    }

    var isLoggedIn = async function()
    {
        let user = localStorage.getItem("user");
        user =  JSON.parse(user);
        if(user.token)
        {
          return true;
        }
        else
        {
          return false;
        }
    }

    var getToken = async function()
    {
        let user = localStorage.getItem("user");
        user =  JSON.parse(user);
        if(user.token)
        {
          return user.token;
        }
        else
        {
          return false;
        }
    }
    
    var logout = async function()
    {
      const history = useHistory();
      await localStorage.removeItem("user");
      history.push('/login');
    }

    return {
      getUser: getUser,
      setUser: setUser,
      isLoggedIn:isLoggedIn,
      logout:logout,
      getToken:getToken
    }
  
  })();
  
  export default UserProfile;
